import React from 'react'

export const createTrimOnBlurHandler = <T extends HTMLElement & { value: string; name: string }>(
  callback: (e: React.FocusEvent<T>) => void,
) => {
  return (e: React.FocusEvent<T>) => {
    const originalValue = e.target.value
    const trimmedValue = originalValue.trim()

    if (trimmedValue === originalValue) {
      callback(e)
      return
    }

    const simulatedEvent = {
      ...e,
      currentTarget: {
        ...e.currentTarget,
        name: e.currentTarget.name,
        value: trimmedValue,
      },
      target: {
        ...e.target,
        // Note: spreading a DOM node does not copy name — must be set explicitly
        name: e.target.name,
        value: trimmedValue,
      },
    } as unknown as React.FocusEvent<T>

    callback(simulatedEvent)
  }
}
